import { render, staticRenderFns } from "./SaijiList.vue?vue&type=template&id=54e08b30&"
import script from "./SaijiList.vue?vue&type=script&lang=js&"
export * from "./SaijiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports